export default "__VITE_ASSET__DQOX6MsV__"